export default {
  custom: () => import("C:/Users/GraphiDev_U3/Documents/_CLIENTS/App/layouts/custom.vue").then(m => m.default || m),
  default: () => import("C:/Users/GraphiDev_U3/Documents/_CLIENTS/App/layouts/default.vue").then(m => m.default || m)
}